export default "__VITE_ASSET__wRlwN0U5__"